import { useEffect, useRef, useState } from "react";
import { CameraEnhancer } from 'dynamsoft-camera-enhancer';

import ImagePreview from './ImagePreview';
import { useStore } from '../../context/appContext';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AdjustRoundedIcon from '@mui/icons-material/AdjustRounded';
import CameraswitchIcon from '@mui/icons-material/Cameraswitch';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { BackgroundContainer, ButtonsContainer, CameraContainer, OvalInner, OvalOuter, SilhouetteImage } from "./cameraStyle";

const dniResolution = { width: 720, height: 1200 };
const selfieResolution = { width: 900, height: 600 };

export const CameraComponent = () => {
    const { setPhoto, setCamera, camera } = useStore();
    const [dataUri, setDataUri] = useState(null);
    const [cameraType, setCameraType] = useState('front')
    
    const enhancer = useRef();
    
    const dniType = camera.type === 'front' || camera.type === 'back' ? true : false;

    async function init () {
        const container = document.getElementById("enhancerUIContainer");

        if (!container) {
            return;
        }

        const cameraInit = await CameraEnhancer.createInstance()
        
        const resolution = dniType ? dniResolution : selfieResolution;

        await cameraInit.setResolution(resolution.width, resolution.height);
        await cameraInit.setUIElement(container);            
        // await cameraInit.setUIElement(CameraEnhancer.defaultUIElementURL);
        
        if (!dniType) {
            container.style.transform = "scaleX(-1)";
            setCameraType('back')

            const cameras = await cameraInit.getAllCameras();

            if (cameras.length) {
                await cameraInit.selectCamera(...cameras.filter(camera => !camera.label.includes('back')))
            }
        }
        
        await cameraInit.open(true);

        if (dniType) {
            let area = { x: 10, y: 8, width: 80, height: 80 };
            cameraInit.setViewDecoratorStrokeStyle("focus", "rgb(47, 79, 131)");
            cameraInit.setViewDecoratorLineWidth("focus", 8);
            cameraInit.setViewDecorator(["focus", "crosshair"], area);
        }

        enhancer.current = cameraInit;
    }

    async function dispose () {
        if(!enhancer.current || enhancer.current.disposed) {
            return;
        }
        await enhancer.current.dispose(false)
    }
    
    async function capture () {
        const isOpen = await enhancer.current.isOpen()
        if (!isOpen) return

        let canvas = await enhancer.current.getFrame().toCanvas();

        const base64Canvas = cameraType === "back" ?
            await mirrorMode(canvas.toDataURL("image/jpeg", 1)) :
            canvas.toDataURL("image/jpeg", 1)
        setDataUri(base64Canvas)
    }

    async function mirrorMode (base64Img) {
        return new Promise((resolve, reject) => {
            const img = new Image();

            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                canvas.width = img.width;
                canvas.height = img.height;

                // Invertir horizontalmente la imagen utilizando transformaciones 2D
                ctx.translate(canvas.width, 0);
                ctx.scale(-1, 1);
                ctx.drawImage(img, 0, 0);

                // Obtener la imagen espejo en formato Base64
                const base64Espejo = canvas.toDataURL("image/jpeg", 1);
                resolve(base64Espejo);
            };

            img.onerror = reject;
            img.src = base64Img;
        });
    };

    async function handleRetakePhoto () {
        if (!dataUri) return;
        setDataUri(null);
    };

    async function handleConfirmPhoto () {
        if (!dataUri) return;
        setPhoto({
            [camera.type]: dataUri,
        });
        setCamera({ open: false });
    };

    async function rotateCamera (enhancer, type) {
        let rotation = ''
        if (type === 'front') {
            rotation = 'back'
            document.getElementById("enhancerUIContainer").style.transform = "scaleX(-1)";
        } else {
            rotation = 'front'
            document.getElementById("enhancerUIContainer").style.transform = null;
        }

        setCameraType(rotation)

        const cameras = await enhancer.current.getAllCameras();

        if (cameras.length) {
            await enhancer.current.selectCamera(...cameras.filter(camera => !camera.label.includes(rotation)))
        }
    }

    useEffect(() => {
        if(dataUri) return;
        init().catch(console.log)
        return () => {
            dispose().catch(console.log);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataUri])

    return (
        <BackgroundContainer>
            {dataUri 
                ? (<ImagePreview dataUri={dataUri} />) 
                : (
                    <div id="enhancerUIContainer" style={{ width: "100%", height: "100%" }}>
                        <CameraContainer className="dce-video-container">
                            {!dniType &&
                                <SilhouetteImage>
                                    <OvalOuter />
                                    <OvalInner />
                                </SilhouetteImage>
                            }
                        </CameraContainer>
                    </div>
                )
            }
            <ButtonsContainer>
                {dataUri ? (
                    <>
                        <HighlightOffIcon color="error" sx={{ fontSize: 80, margin: '0 0 5% 20%' }} onClick={handleRetakePhoto} />
                        <CheckCircleOutlineIcon color="success" sx={{ fontSize: 80, margin: '0 20% 5% 0' }} onClick={handleConfirmPhoto} />

                    </>
                ) : (
                    <>
                        <AdjustRoundedIcon sx={{ color: "#2f4f83", fontSize: 80, marginLeft: "32%" }} onClick={capture} />
                        <CameraswitchIcon sx={{ color: "#2f4f83", fontSize: 40 }} onClick={() => rotateCamera(enhancer, cameraType)} />

                    </>
                )}
            </ButtonsContainer>
        </BackgroundContainer>
    )

};